import { render, staticRenderFns } from "./PrintableTeamScores.vue?vue&type=template&id=69efab48&"
import script from "./PrintableTeamScores.vue?vue&type=script&lang=js&"
export * from "./PrintableTeamScores.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports